webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leancloud_storage__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leancloud_storage__);


var APP_ID = 'MovmRmeTjl1i18FkHuXRmW6c-gzGzoHsz';
var APP_KEY = '6iIwVpOPza8RSR42yDleSzUh';
__WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default.a.init({
  appId: APP_ID,
  appKey: APP_KEY
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default.a);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__ = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["a"] = (function (user) {
  var _ref = user || __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__["a" /* default */].User.current() || { attributes: {} },
      id = _ref.id,
      username = _ref.attributes.username;

  return { id: id, username: username };
});

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var map = {
  202: '用户名已被占用',
  210: '用户名和密码不匹配',
  211: '找不到该用户',
  217: '无效的用户名',
  unknown: '请求失败，请稍后再试'
};
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var code = _ref.code;

  return map[code] || map.unknown;
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(82),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-516b402e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(78),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_reset_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalize_css_normalize_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Topbar__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Topbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResumeEditor__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResumeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ResumeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumePreview__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResumePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ResumePreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SignInAndSignUp__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SignInAndSignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SignInAndSignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_index__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_leancloud__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_getAVUser__ = __webpack_require__(2);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  store: __WEBPACK_IMPORTED_MODULE_7__store_index__["a" /* default */],
  currentUser: null,
  components: { Topbar: __WEBPACK_IMPORTED_MODULE_2__components_Topbar___default.a, ResumeEditor: __WEBPACK_IMPORTED_MODULE_3__components_ResumeEditor___default.a, ResumePreview: __WEBPACK_IMPORTED_MODULE_4__components_ResumePreview___default.a, SignInAndSignUp: __WEBPACK_IMPORTED_MODULE_5__components_SignInAndSignUp___default.a },
  created: function created() {
    document.body.insertAdjacentHTML('afterbegin', __WEBPACK_IMPORTED_MODULE_6__assets_icons__["a" /* default */]);
    var state = localStorage.getItem('state');

    if (state) {
      state = JSON.parse(state);
    }
    this.$store.commit('initState', state);
    this.$store.commit('setUser', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_getAVUser__["a" /* default */])());
    this.currentUser = __WEBPACK_IMPORTED_MODULE_5__components_SignInAndSignUp___default.a.methods.getCurrentUser();
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MyDialog'
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResumeEditor',

  computed: {
    selected: {
      get: function get() {
        return this.$store.state.selected;
      },
      set: function set(value) {
        return this.$store.commit('switchTab', value);
      }
    },
    resume: function resume() {
      return this.$store.state.resume;
    }
  },
  methods: {
    changeResumeField: function changeResumeField(path, value) {
      this.$store.commit('updateResume', {
        path: path,
        value: value
      });
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResumePreview',
  computed: {
    resume: function resume() {
      return this.$store.state.resume;
    }
  },
  createt: function createt() {
    console.log(this.resume);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getErrorMessage__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getAVUser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyDialog__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MyDialog__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SignInAndSignUp',
  data: function data() {
    return {
      currentUser: null,
      actionType: 'signUp',
      formData: {
        username: '',
        password: ''
      },
      errorMessage: ''
    };
  },

  components: {
    MyDialog: __WEBPACK_IMPORTED_MODULE_4__MyDialog___default.a
  },
  created: function created() {
    this.currentUser = this.getCurrentUser();

    this.fetchTodos();
  },
  methods: {
    fetchTodos: function fetchTodos() {
      var _this = this;

      if (this.currentUser) {
        var query = new __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].Query('AllTodos');
        query.find().then(function (todos) {
          var avAllTodos = todos[0];
          var id = avAllTodos.id;
          console.log(avAllTodos);
          _this.todoList = JSON.parse(avAllTodos.attributes.content);
          _this.todoList.id = id;
        }, function (error) {
          console.error(error);
        });
      }
    },
    updateTodos: function updateTodos() {
      var _this2 = this;

      var dataString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.todoList);
      var avTodos = __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].Object.createWithoutData('AllTodos', this.todoList.id);
      avTodos.set('content', dataString);
      avTodos.save().then(function () {
        _this2.todoList.id = todo.id;
        console.log('更新成功');
      });
    },
    saveTodos: function saveTodos() {
      var _this3 = this;

      var dataString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.todoList);

      var AVTodos = __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].Object.extend('AllTodos');
      var avTodos = new AVTodos();

      var acl = new __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].ACL();
      acl.setReadAccess(__WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User.current(), true);
      acl.setWriteAccess(__WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User.current(), true);

      avTodos.set('content', dataString);
      avTodos.setACL(acl);
      avTodos.save().then(function (todo) {
        _this3.todoList.id = todo.id;
        console.log('保存成功');
      }, function (error) {
        console.error('保存失败');
      });
    },
    saveOrUpdateTodos: function saveOrUpdateTodos() {
      if (this.todoList.id) {
        this.updateTodos();
      } else {
        this.saveTodos();
      }
    },
    addTodo: function addTodo() {
      this.todoList.push({
        title: this.newTodo,
        createdAt: bar(new Date()),
        done: false });
      this.newTodo = '';
      this.saveOrUpdateTodos();
    },
    isSelected: function isSelected() {
      for (var i = 0; i < this.todoList.length; i++) {
        if (this.todoList[i].done == false) {
          this.todoList.done == true;
          this.saveOrUpdateTodos();
        } else if (this.todoList[i].done == true) {
          this.todoList.done == false;
          this.saveOrUpdateTodos();
        }
      }
    },
    isActive: function isActive() {},
    isValidUsername: function isValidUsername() {
      var reg = /^\w{6,20}$/;
      var str = this.formData.username;
      if (reg.test(str)) {
        console.log('输入的用户名正确');
      } else {
        this.formData.username = '';
        console.log('请输入正确的用户名');
      }
    },
    isValidPassword: function isValidPassword() {
      var reg = /^\w{6,20}$/;
      var str = this.formData.password;
      if (reg.test(str)) {
        if (/^[a-z]{6,20}$/.test(str) || /^[A-Z]{6,20}$/.test(str) || /^[0-9]{6,20}$/.test(str) || /^-{6,20}$/.test(str)) {
          console.log('请重新输入密码');
          this.formData.password = '';
        } else {
          console.log('输入的密码正确');
        }
      } else {
        console.log('请重新输入密码');

        this.formData.password = '';
      }
    },
    removeTodo: function removeTodo(todo) {
      var index = this.todoList.indexOf(todo);
      this.todoList.splice(index, 1);
      this.saveOrUpdateTodos();
    },
    signUp: function signUp() {
      var _this4 = this;

      var user = new __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User();
      user.setUsername(this.formData.username);
      user.setPassword(this.formData.password);
      user.signUp().then(function (loginedUser) {
        _this4.currentUser = _this4.getCurrentUser();
      }, function (error) {
        alert('注册失败');
      });
    },
    signIn: function signIn() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User.logIn(this.formData.username, this.formData.password).then(function (loginedUser) {
        _this5.currentUser = _this5.getCurrentUser();
        window.location.reload();
        _this5.fetchTodos();
      }, function (error) {
        alert('登录失败');
      });
    },
    getCurrentUser: function getCurrentUser() {

      var current = __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User.current();
      if (current) {
        var id = current.id,
            createdAt = current.createdAt,
            username = current.attributes.username;

        return { id: id, username: username, createdAt: createdAt };
      } else {
        return null;
      }
    },
    logined: function logined() {
      this.currentUser = this.getCurrentUser();
      window.location.reload();
    },

    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1__lib_leancloud__["a" /* default */].User.logOut();
      this.currentUser = null;
      window.location.reload();
    }
  }

});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SignUpForm',
  data: function data() {
    return {
      formData: {
        username: '',
        password: ''
      },
      errorMessage: ''
    };
  },

  methods: {
    signIn: function signIn() {
      var _this = this;

      var _formData = this.formData,
          username = _formData.username,
          password = _formData.password;

      __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__["a" /* default */].User.logIn(username, password).then(function () {
        _this.$emit('success', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__["a" /* default */])());
      }, function (error) {
        _this.errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__["a" /* default */])(error);
      });
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SignUpForm',
  data: function data() {
    return {
      formData: {
        username: '',
        password: ''
      },
      errorMessage: ''
    };
  },
  created: function created() {},

  methods: {
    signUp: function signUp() {
      var _this = this;

      var _formData = this.formData,
          username = _formData.username,
          password = _formData.password;

      var user = new __WEBPACK_IMPORTED_MODULE_0__lib_leancloud__["a" /* default */].User();
      user.setUsername(username);
      user.setPassword(password);
      user.signUp().then(function () {
        _this.$emit('success', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_getAVUser__["a" /* default */])());
      }, function (error) {
        _this.errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_getErrorMessage__["a" /* default */])(error);
      });
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyDialog__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignUpForm__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignUpForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SignUpForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignInForm__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignInForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SignInForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_leancloud__ = __webpack_require__(1);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topbar',
  data: function data() {
    return {
      signUpDialogVisible: false,
      signInDialogVisible: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.user;
    },
    logined: function logined() {
      return this.user.id;
    }
  },
  components: {
    MyDialog: __WEBPACK_IMPORTED_MODULE_0__MyDialog___default.a, SignUpForm: __WEBPACK_IMPORTED_MODULE_1__SignUpForm___default.a, SignInForm: __WEBPACK_IMPORTED_MODULE_2__SignInForm___default.a
  },
  methods: {
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_3__lib_leancloud__["a" /* default */].User.logOut();

      window.location.reload();
      this.$store.commit('removeUser');
    },
    signIn: function signIn(user) {
      this.signUpDialogVisible = false;
      this.signInDialogVisible = false;
      this.$store.commit('setUser', user);
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("<svg style=\"display:none\">\n<symbol id=\"icon-add\" width=\"200px\" height=\"200.00px\" viewBox=\"0 0 1024 1024\" ><path d=\"M1000.704728 1023.968001h-139.643636a23.295272 23.295272 0 0 1 0-46.558545h116.348364V861.093091a23.295272 23.295272 0 0 1 46.558545 0v139.643636a23.295272 23.295272 0 0 1-23.263273 23.263273z m0-279.255273a23.295272 23.295272 0 0 1-23.295272-23.295272v-139.611637a23.295272 23.295272 0 0 1 46.558545 0v139.611637a23.295272 23.295272 0 0 1-23.263273 23.295272z m0-279.287273a23.295272 23.295272 0 0 1-23.295272-23.263273V302.550545a23.295272 23.295272 0 0 1 46.558545 0v139.611637a23.295272 23.295272 0 0 1-23.263273 23.263273z m0-279.255273a23.295272 23.295272 0 0 1-23.295272-23.263273V46.558545H861.093091a23.295272 23.295272 0 0 1 0-46.558545h139.643636c12.7996 0 23.263273 10.431674 23.263273 23.263273v139.643636a23.295272 23.295272 0 0 1-23.263273 23.263273zM721.417456 1023.968001h-139.611637a23.295272 23.295272 0 0 1 0-46.558545h139.611637a23.295272 23.295272 0 0 1 0 46.558545z m0-977.409456h-139.611637a23.295272 23.295272 0 0 1 0-46.558545h139.611637a23.295272 23.295272 0 0 1 0 46.558545z m-26.143183 418.86691a46.526546 46.526546 0 1 1 0 93.117091h-139.643636v139.611637a46.558545 46.558545 0 0 1-93.085092 0v-139.611637h-139.611637a46.558545 46.558545 0 0 1 0-93.117091h139.611637v-139.611637a46.526546 46.526546 0 1 1 93.117091 0v139.611637h139.611637z m-253.112091-418.86691H302.550545a23.295272 23.295272 0 0 1 0-46.558545h139.611637a23.295272 23.295272 0 0 1 0 46.558545zM162.906909 1023.968001H23.263273A23.295272 23.295272 0 0 1 0 1000.704728v-139.643636a23.295272 23.295272 0 0 1 46.558545 0v116.348364H162.87491a23.295272 23.295272 0 0 1 0 46.558545z m0-977.409456H46.558545V162.87491A23.295272 23.295272 0 0 1 0 162.87491V23.263273C0 10.431674 10.431674 0 23.263273 0h139.643636a23.295272 23.295272 0 0 1 0 46.558545zM23.263273 279.255273c12.863598 0 23.295272 10.431674 23.295272 23.295272v139.611637a23.295272 23.295272 0 0 1-46.558545 0V302.550545c0-12.863598 10.431674-23.295272 23.263273-23.295272z m0 279.287273c12.863598 0 23.295272 10.399675 23.295272 23.263273v139.611637a23.295272 23.295272 0 0 1-46.558545 0v-139.611637c0-12.863598 10.431674-23.263273 23.263273-23.263273z m279.287272 418.86691h139.611637a23.295272 23.295272 0 0 1 0 46.558545H302.550545a23.295272 23.295272 0 0 1 0-46.558545z\" /></symbol>\n<symbol id=\"icon-book\" width=\"200px\" height=\"168.84px\" viewBox=\"0 0 1213 1024\" ><path d=\"M1211.58163 124.09363s-68.645926-57.685333-138.808889-88.064c-76.382815-37.05363-184.32-35.346963-184.32-35.346963s-76.003556-5.688889-153.941334 31.478518a658.773333 658.773333 0 0 0-135.471407 87.684741S519.585185 58.405926 449.308444 26.244741C379.031704-5.95437 277.617778 0.682667 277.617778 0.682667S181.172148 5.688889 119.125333 33.867852C57.002667 62.084741 0 129.21363 0 129.21363V994.797037s87.722667-76.724148 140.060444-98.304 134.181926-20.859259 134.181926-20.859259 98.076444 11.908741 156.520297 35.764148c58.405926 23.893333 168.239407 112.336593 168.239407 112.336593s70.011259-75.472593 126.217482-103.80326c95.269926-49.796741 189.743407-42.590815 189.743407-42.590815s58.026667 2.578963 138.808889 33.223112c73.424593 27.83763 159.250963 85.940148 159.250963 85.940148l-1.517037-872.410074zM569.192296 928.426667s-150.262519-120.187259-294.912-117.456593c-136.305778 2.541037-188.453926 37.432889-223.762963 73.197037 1.251556-42.097778-0.644741-723.512889-0.64474-723.512889s52.337778-95.269926 229.072592-102.930963c150.186667-12.781037 279.74163 94.435556 287.706074 114.915556 3.792593 26.775704 2.541037 755.787852 2.541037 755.787852z m586.827852-28.065186c-35.309037-35.764148-129.972148-89.391407-266.277926-91.932444-144.649481-2.730667-258.503111 121.287111-258.503111 121.287111s-1.289481-729.012148 2.503111-755.825778c12.629333-20.404148 111.085037-122.538667 287.744-114.915555 153.144889 6.750815 236.506074 100.617481 236.506074 100.617481s-1.820444 698.974815-1.972148 740.73126z\" /></symbol>\n<symbol id=\"icon-cup\" width=\"200px\" height=\"200.00px\" viewBox=\"0 0 1024 1024\" ><path d=\"M257.613576 557.676606a17.811394 17.811394 0 0 1-5.306182-0.806788l-29.416727-8.998788a18.059636 18.059636 0 0 1-4.468364-2.016969C78.072242 456.921212 10.053818 372.70497 16.259879 295.501576 23.024485 210.944 115.246545 170.790788 119.156364 169.115152a18.214788 18.214788 0 0 1 7.136969-1.458425h17.873455c9.867636 0 17.997576 7.881697 18.369939 17.842425 5.740606 141.28097 110.312727 342.884848 111.336728 344.901818a18.742303 18.742303 0 0 1-2.048 20.48 18.307879 18.307879 0 0 1-14.211879 6.826666zM127.069091 206.506667c-18.307879 9.557333-70.128485 40.92897-74.162424 92.16-4.499394 58.212848 52.844606 128.341333 166.198303 203.465697-30.471758-65.784242-82.354424-190.526061-92.035879-295.625697z m652.443151 344.622545a18.307879 18.307879 0 0 1-13.498181-5.957818 18.742303 18.742303 0 0 1-3.227152-20.355879c0.930909-2.07903 93.835636-209.423515 91.477333-350.797576a18.525091 18.525091 0 0 1 17.34594-18.897454l17.811394-1.024a18.959515 18.959515 0 0 1 7.23006 1.024c4.002909 1.458424 98.33503 36.150303 109.909334 120.180363 10.581333 76.737939-52.503273 164.770909-187.547152 261.709576a18.618182 18.618182 0 0 1-4.313212 2.296243l-28.858182 10.705454a17.935515 17.935515 0 0 1-6.330182 1.117091zM890.88 192.915394c-3.692606 105.472-48.345212 233.006545-75.031273 300.466424 108.885333-81.578667 162.133333-154.903273 154.282667-212.774788-6.888727-50.889697-60.38497-79.189333-79.251394-87.691636z\" /><path d=\"M511.100121 737.900606c-221.059879 0-400.911515-300.807758-400.911515-670.533818 0-13.312 0.279273-26.499879 0.713697-39.594667a27.741091 27.741091 0 0 1 27.61697-26.934303h745.161697c14.894545 0 27.089455 11.915636 27.585939 26.934303 0.434424 13.094788 0.744727 26.282667 0.744727 39.594667 0 369.726061-179.851636 670.533818-400.911515 670.533818zM165.453576 56.630303l-0.062061 10.736485c0 338.97503 155.089455 614.710303 345.708606 614.710303s345.708606-275.735273 345.708606-614.710303c0-3.599515 0-7.13697-0.06206-10.736485H165.453576z\" /><path d=\"M579.025455 602.049939a18.649212 18.649212 0 0 1-7.230061-35.684848c122.352485-53.030788 156.082424-206.041212 156.392727-207.561697a18.46303 18.46303 0 0 1 21.845334-14.30497 18.618182 18.618182 0 0 1 14.180848 22.031515c-1.458424 7.043879-37.794909 173.304242-177.958788 233.999516a17.935515 17.935515 0 0 1-7.23006 1.520484z m-67.925334 272.32194c-15.235879 0-27.61697-10.550303-27.616969-23.583031v-145.097696c0-13.032727 12.381091-23.58303 27.616969-23.583031s27.61697 10.550303 27.61697 23.583031v145.097696c0 13.032727-12.381091 23.58303-27.61697 23.583031z\" /><path d=\"M747.675152 1023.875879H287.961212a27.772121 27.772121 0 0 1-27.61697-27.927273c0-92.966788 113.105455-165.825939 257.458425-165.825939 144.384 0 257.458424 72.859152 257.458424 165.856969a27.772121 27.772121 0 0 1-27.61697 27.896243zM322.466909 968.083394h390.733576c-23.365818-46.669576-103.39297-82.168242-195.366788-82.168242-91.973818 0-172.00097 35.498667-195.366788 82.168242z\" /></symbol>\n<symbol id=\"icon-heart\" width=\"200px\" height=\"187.55px\" viewBox=\"0 0 1092 1024\" ><path d=\"M1090.321067 305.732267c-15.906133-176.64-140.0832-304.810667-295.5264-304.810667-103.5264 0-198.382933 56.081067-251.733334 145.988267C490.1888 55.876267 399.291733 0.9216 297.3696 0.9216 141.9264 0.9216 17.749333 129.092267 1.8432 305.664c-1.262933 7.850667-6.485333 48.878933 9.284267 115.848533 22.596267 96.597333 74.922667 184.388267 151.210666 253.952l380.450134 347.477334 387.037866-347.477334c76.288-69.563733 128.580267-157.354667 151.210667-253.952 15.7696-66.9696 10.581333-108.032 9.284267-115.780266z m-50.176 106.052266c-20.650667 88.2688-68.608 168.618667-138.4448 232.2432L543.061333 966.109867 190.5664 644.096c-69.973333-63.7952-117.896533-144.110933-138.581333-232.3456-14.848-63.351467-8.704-99.157333-8.704-99.328l0.3072-2.1504c13.653333-154.794667 120.354133-267.093333 253.781333-267.093333 98.440533 0 185.105067 60.893867 226.269867 158.856533l19.319466 46.216533 19.319467-46.216533c40.482133-96.4608 131.754667-158.8224 232.516267-158.8224 133.393067 0 240.128 112.298667 254.0544 269.038933 0.068267 0.341333 6.212267 36.181333-8.704 99.498667z\" /><path d=\"M336.0768 129.467733c-115.848533 0-210.056533 94.8224-210.056533 211.387734 0 11.6736 9.4208 21.162667 21.026133 21.162666 11.605333 0 20.992-9.489067 20.992-21.162666 0-93.2864 75.3664-169.130667 168.0384-169.130667 11.605333 0 20.992-9.454933 20.992-21.128533a21.060267 21.060267 0 0 0-20.992-21.162667z\" /></symbol>\n<symbol id=\"icon-id\" width=\"200px\" height=\"156.34px\" viewBox=\"0 0 1310 1024\" ><path d=\"M370.4832 464.52736c-82.82112 0-150.15936-66.68288-150.15936-148.6848 0-81.92 67.33824-148.60288 150.15936-148.60288 82.78016 0 150.15936 66.68288 150.15936 148.64384 0 81.92-67.3792 148.64384-150.15936 148.64384z m0-245.67808c-54.0672 0-98.01728 43.54048-98.01728 97.03424 0 53.49376 43.95008 97.03424 98.01728 97.03424 54.02624 0 97.97632-43.54048 97.97632-97.0752 0-53.4528-43.95008-96.99328-97.97632-96.99328z m218.27584 410.29632H536.576c0-90.68544-74.5472-164.4544-166.13376-164.4544-91.62752 0-166.13376 73.728-166.13376 164.4544H152.20736c0-119.1936 97.8944-216.10496 218.27584-216.10496 120.34048 0 218.27584 96.95232 218.27584 216.10496z m637.7472 394.15808H84.1728c-45.6704 0-82.86208-36.864-82.86208-82.08384V82.86208C1.31072 37.60128 38.5024 0.77824 84.1728 0.77824h1142.3744c45.6704 0 82.86208 36.864 82.86208 82.08384v858.35776a82.61632 82.61632 0 0 1-82.90304 82.08384zM84.1728 52.4288a30.59712 30.59712 0 0 0-30.72 30.43328v858.35776c0 16.7936 13.80352 30.43328 30.72 30.43328h1142.3744c16.91648 0 30.72-13.68064 30.72-30.43328V82.86208a30.63808 30.63808 0 0 0-30.72-30.43328H84.13184z m643.60448 206.97088h410.29632v51.6096H727.77728v-51.6096z m0 247.07072h410.29632v51.6096H727.77728v-51.6096zM151.01952 742.89152h987.05408v51.6096H151.01952v-51.6096z\" /></symbol>\n<symbol id=\"icon-phone\" width=\"200px\" height=\"200.00px\" viewBox=\"0 0 1024 1024\" ><path d=\"M197.632381 41.178403c37.763833 0 140.877405 98.769335 172.435185 165.174103 7.136961 14.956588 9.464231 27.772088 5.740599 31.123356L330.84531 278.342722c-32.116325 29.23051-49.182971 59.981503-50.765514 91.353101-1.644604 31.55778 12.319015 63.363802 41.363344 94.518189l242.532555 260.002594c30.44069 32.7059 61.657137 48.562365 95.356005 48.562365 31.216447 0 61.688168-13.901559 93.152857-42.573524l44.838734-40.835829c1.17915-1.086059 2.761694-1.489453 4.995872-1.644604 37.794863 0 128.930753 90.949708 155.399569 146.773155 7.447264 15.670284 9.464231 28.423723 5.213085 32.271476l-44.838733 40.773769c-44.869764 40.835829-95.200854 65.256648-149.379698 72.393609a253.548299 253.548299 0 0 1-33.543717 2.203149c-87.319167 0-175.786454-43.28722-249.110971-121.855852L161.358001 512.372984C26.376346 367.647826 21.597685 199.184515 149.101046 83.224413l44.931824-40.835829a5.461327 5.461327 0 0 1 3.009936-1.14812l0.589575-0.062061z m0-41.177162a47.476306 47.476306 0 0 0-32.054264 12.163864L120.801444 52.907844c-143.887341 130.823599-139.977527 326.655604 9.836594 487.299288l324.638637 348.097517c81.392386 87.288137 181.527053 135.198866 279.799903 135.198867 13.063742 0 26.127483-0.837817 39.098135-2.575512 62.929378-8.285081 120.862884-36.21232 172.217973-82.97493l44.838733-40.773769c13.498165-12.225925 25.227606-36.057168 4.344237-80.120145-28.299602-59.485019-128.992813-170.511308-193.163402-170.511309a48.438244 48.438244 0 0 0-33.202384 12.505197l-45.024915 40.990981c-23.055487 20.945429-44.187098 31.650871-64.853255 31.650871-21.535004 0-42.511464-11.605319-64.542952-35.343473l-242.625645-260.002593c-21.224702-22.776215-31.464689-44.46637-30.37863-64.511922 0.992968-20.386884 13.560226-41.580556 37.36044-63.270711l44.869763-40.742739c13.218893-12.008713 24.54494-35.436563 3.816723-78.972025C376.894224 123.687879 263.044181 0.001241 197.663411 0.001241z\" /></symbol>\n<symbol id=\"icon-work\" width=\"200px\" height=\"181.40px\" viewBox=\"0 0 1129 1024\" ><path d=\"M971.74069 178.811586H790.951724v-66.736552c0-62.252138-49.716966-111.192276-112.993103-111.192275h-225.986207c-63.276138 0-112.993103 48.940138-112.993104 111.227586v66.701241H158.190345C70.055724 178.811586 0 247.737379 0 334.494897v533.715862c0 86.757517 70.055724 155.68331 158.190345 155.68331h813.550345c88.134621 0 158.190345-68.925793 158.190344-155.68331V334.494897c0-86.757517-72.315586-155.718621-158.190344-155.718621z m-587.564138-66.736552c0-37.782069 29.378207-66.701241 67.795862-66.701241h225.986207c38.417655 0 67.795862 28.919172 67.795862 66.736552v66.701241H384.176552v-66.736552z m-225.986207 111.227587h813.550345c63.276138 0 112.993103 48.904828 112.993103 111.192276v206.812689L564.965517 748.120276 45.197241 541.307586V334.494897c0-62.287448 49.716966-111.227586 112.993104-111.227587z m813.550345 756.100413H158.190345c-63.276138 0-112.993103-48.904828-112.993104-111.192275v-277.963035L564.965517 797.060414l519.768276-206.81269v277.963035c0 60.027586-51.976828 111.227586-112.993103 111.227586z\" /></symbol>\n</svg>");

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(16);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Vuex__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_path__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_path__);






__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_Vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_Vuex__["a" /* default */].Store({
  state: {
    count: 0,
    selected: 'profile',
    user: {
      id: '',
      username: ''
    },
    formData: {
      username: '',
      password: ''
    },

    resume: {
      config: [{ field: 'profile', icon: 'id' }, { field: 'workHistory', icon: 'work' }, { field: 'education', icon: 'book' }, { field: 'projects', icon: 'heart' }, { field: 'awards', icon: 'cup' }, { field: 'contacts', icon: 'phone' }, { field: 'others', icon: 'add' }],
      profile: {
        name: '熊某某',
        sex: '男',
        birthday: '1993-01-01',
        city: '广州',
        title: '首席装逼师'
      },
      'workHistory': [{ company: '鸡飞狗跳公司', content: '\u516C\u53F8\u603B\u90E8\u8BBE\u5728XXXX\u533A\uFF0C\u5148\u540E\u5728\u5317\u4EAC\u3001\u4E0A\u6D77\u6210\u7ACB\u5206\u516C\u53F8\u3002\u4E13\u6CE8\u4E8E\u79FB\u52A8XXX\u9886\u57DF\uFF0C\u4E3B\u6253\u4EA7\u54C1XXXXX\uFF0C\u5B83\u5C06\u8D44\u8BAF\u3001\u62A5\u7EB8\u3001\u6742\u5FD7\u3001\u56FE\u7247\u3001\u5FAE\u4FE1\u7B49\u4F17\u591A\u5185\u5BB9\uFF0C\u6309\u7167\u7528\u6237\u610F\u613F\u805A\u5408\u5230\u4E00\u8D77\uFF0C\u5B9E\u73B0\u6DF1\u5EA6\u4E2A\u6027\u5316 \u5B9A\u5236\u3002\n        \u6211\u7684\u4E3B\u8981\u5DE5\u4F5C\u5982\u4E0B:\n        1. \u5B8C\u6210\u65E2\u5B9A\u4EA7\u54C1\u9700\u6C42\u3002\n        2. \u4FEE\u590D bug\u3002' }, { company: '狗急跳墙责任有限公司', content: '\u516C\u53F8\u603B\u90E8\u8BBE\u5728XXXX\u533A\uFF0C\u5148\u540E\u5728\u5317\u4EAC\u3001\u4E0A\u6D77\u6210\u7ACB\u5206\u516C\u53F8\u3002\u4E13\u6CE8\u4E8E\u79FB\u52A8XXX\u9886\u57DF\uFF0C\u4E3B\u6253\u4EA7\u54C1XXXXX\uFF0C\u5B83\u5C06\u8D44\u8BAF\u3001\u62A5\u7EB8\u3001\u6742\u5FD7\u3001\u56FE\u7247\u3001\u5FAE\u4FE1\u7B49\u4F17\u591A\u5185\u5BB9\uFF0C\u6309\u7167\u7528\u6237\u610F\u613F\u805A\u5408\u5230\u4E00\u8D77\uFF0C\u5B9E\u73B0\u6DF1\u5EA6\u4E2A\u6027\u5316 \u5B9A\u5236\u3002\n        \u6211\u7684\u4E3B\u8981\u5DE5\u4F5C\u5982\u4E0B:\n        1. \u5B8C\u6210\u65E2\u5B9A\u4EA7\u54C1\u9700\u6C42\u3002\n        2. \u4FEE\u590D bug\u3002' }],
      education: [{ school: '黄志诚警官大学', content: '本科' }, { school: '韩琛古惑仔高中', content: '高中' }],
      projects: [{ name: 'project A', content: '文字' }, { name: 'project B', content: '文字' }],
      awards: [{ name: '再来十瓶', content: '连续十次获得「再来一瓶」奖励' }, { name: '三好学生', content: '连续三次获得「三好学生」奖励' }],
      contacts: [{ contact: 'phone', content: '13812345678' }, { contact: 'qq', content: '12345678' }],
      others: []
    }

  },
  mutations: {
    initState: function initState(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, payload);
    },
    switchTab: function switchTab(state, payload) {
      state.selected = payload;
      localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    updateResume: function updateResume(state, _ref) {
      var path = _ref.path,
          value = _ref.value;

      __WEBPACK_IMPORTED_MODULE_4_object_path___default.a.set(state.resume, path, value);
      localStorage.setItem('state', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
    },
    setUser: function setUser(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.user, payload);
    },
    removeUser: function removeUser(state) {
      state.user.id = null;
    }
  }
}));

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-890bdb66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(64)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(83),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-694a504f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(86),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(79),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37762888",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(80),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(84),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c25eeb3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.currentUser) ? _c('div', [_c('signInAndSignUp')], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('div', {
    staticClass: "page"
  }, [_c('header', [_c('Topbar')], 1), _vm._v(" "), _c('main', [_c('ResumeEditor'), _vm._v(" "), _c('ResumePreview')], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signInAndSignUp"
    }
  }, [_c('MyDialog', {
    attrs: {
      "visible": _vm.signUpDialogVisible
    }
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('label', {
    class: {
      active: _vm.actionType == 'signUp'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionType),
      expression: "actionType"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "signUp"
    },
    domProps: {
      "checked": _vm._q(_vm.actionType, "signUp")
    },
    on: {
      "__c": function($event) {
        _vm.actionType = "signUp"
      }
    }
  }), _vm._v("注册")]), _vm._v(" "), _c('label', {
    class: {
      active: _vm.actionType == 'signIn'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionType),
      expression: "actionType"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "signIn"
    },
    domProps: {
      "checked": _vm._q(_vm.actionType, "signIn")
    },
    on: {
      "__c": function($event) {
        _vm.actionType = "signIn"
      }
    }
  }), _vm._v("登入")])]), _vm._v(" "), (_vm.actionType == 'signUp') ? _c('div', {
    staticClass: "signUp"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("账号:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "账号(字母、数字、特殊符号，6—16位)"
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  }), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码(字母、数字、特殊符号，6—16位，至少2种)"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formActions",
    on: {
      "click": _vm.isValidUsername
    }
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "注册"
    },
    on: {
      "click": _vm.isValidPassword
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.actionType == 'signIn') ? _c('div', {
    staticClass: "signIn"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("账号:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formRow"
  }, [_c('label', [_vm._v("密码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "formActions"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "登入"
    }
  })])])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "提交"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "errorMessage"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])])])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signUp($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "提交"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "errorMessage"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])])])
},staticRenderFns: []}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialogWrapper"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('main', [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resumeEditor"
    }
  }, [_c('nav', [_c('ol', _vm._l((_vm.resume.config), function(item, index) {
    return _c('li', {
      class: {
        active: item.field === _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.selected = item.field
        }
      }
    }, [_c('svg', {
      staticClass: "icon"
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.icon))
      }
    })])])
  }))]), _vm._v(" "), _c('ol', {
    staticClass: "panels"
  }, _vm._l((_vm.resume.config), function(item) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.field === _vm.selected),
        expression: "item.field === selected"
      }]
    }, [(_vm.resume[item.field] instanceof Array) ? _c('div', _vm._l((_vm.resume[item.field]), function(subitem, i) {
      return _c('div', {
        staticClass: "subitem"
      }, [_vm._l((subitem), function(value, key) {
        return _c('div', {
          staticClass: "resumeField"
        }, [_c('label', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('input', {
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": value
          },
          on: {
            "input": function($event) {
              _vm.changeResumeField(((item.field) + "." + i + "." + key), $event.target.value)
            }
          }
        })])
      }), _vm._v(" "), _c('hr')], 2)
    })) : _vm._l((_vm.resume[item.field]), function(value, key) {
      return _c('div', {
        staticClass: "resumeField"
      }, [_c('label', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": value
        },
        on: {
          "input": function($event) {
            _vm.changeResumeField(((item.field) + "." + key), $event.target.value)
          }
        }
      })])
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "logo"
  }, [_vm._v("Resumer")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userActions"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("你好，" + _vm._s(_vm.user.username))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("登出")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button primary"
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("预览")])])])])
},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resumePreview"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.profile),
      expression: "resume.profile"
    }],
    attrs: {
      "data-name": "profile"
    }
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.resume.profile.name) + "\n    ")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.resume.profile.title))]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.resume.profile.city))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.resume.profile.birthday))])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.education),
      expression: "resume.education"
    }],
    attrs: {
      "data-name": "projects"
    }
  }, [_c('h2', [_vm._v("项目经历")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.projects), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.workHistory),
      expression: "resume.workHistory"
    }],
    attrs: {
      "data-name": "workHistory"
    }
  }, [_c('h2', [_vm._v("工作经历")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.workHistory), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.company))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.education),
      expression: "resume.education"
    }],
    attrs: {
      "data-name": "education"
    }
  }, [_c('h2', [_vm._v("毕业院校")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.education), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.school) + "\n          "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" - " + _vm._s(item.content) + " ")])])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.awards),
      expression: "resume.awards"
    }],
    attrs: {
      "data-name": "awards"
    }
  }, [_c('h2', [_vm._v("获奖情况")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.awards), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.contacts),
      expression: "resume.contacts"
    }],
    attrs: {
      "data-name": "contacts"
    }
  }, [_c('h2', [_vm._v("联系方式")]), _vm._v(" "), _c('table', _vm._l((_vm.resume.contacts), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.contact))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))])])
},staticRenderFns: []}

/***/ })
],[28]);


// WEBPACK FOOTER //
// static/js/app.4a2fcbcfc98002153b6c.js